export default __webpack_public_path__ + "static/article-managing-the-christmas-budget-844c6342d8fd6c3013c78722746a2e13.jpg";